import React from 'react';
import PropTypes from 'prop-types';
import { Check, X } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'src/components/ui/tooltip';

// Ported from the old RequirementPipeline.jsx's renderEmailStatusIcons /
// getEmailStatusColor / EMAIL_STATUS_LABELS — a row of 4 dots showing the
// test-link email's delivery lifecycle (delivered → opened → clicked, or
// bounced). Only meaningful for the "Pending" (test link sent) tab.
const STATUS_ORDER = ['delivered', 'email_open', 'email_click', 'bounced'];

const STATUS_LABELS = {
  delivered: 'Delivered',
  email_open: 'Email Opened',
  email_click: 'Link Clicked',
  bounced: 'Bounced',
};

const STATUS_COLORS = {
  delivered: '#F59E0B', // amber
  email_open: '#2168B2', // blue
  email_click: '#10B981', // green
  bounced: '#EF4444', // red
};

const INACTIVE_COLOR = '#E5E5E5';

const EmailStatusIcons = ({ emailStatus }) => {
  const deliveryStatus = emailStatus?.delivery_status || {};

  return (
    <div className="flex gap-1">
      {STATUS_ORDER.map((status) => {
        const active = Boolean(deliveryStatus[status]);
        return (
          <TooltipProvider key={status}>
            <Tooltip delayDuration={0}>
              <TooltipTrigger asChild>
                <div
                  className="w-4 h-4 rounded-full border border-gray-300 flex items-center justify-center"
                  style={{
                    backgroundColor: active
                      ? STATUS_COLORS[status]
                      : INACTIVE_COLOR,
                  }}
                >
                  {active &&
                    (status === 'bounced' ? (
                      <X className="w-2.5 h-2.5 text-white" strokeWidth={3} />
                    ) : (
                      <Check
                        className="w-2.5 h-2.5 text-white"
                        strokeWidth={3}
                      />
                    ))}
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p>{STATUS_LABELS[status]}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        );
      })}
    </div>
  );
};

EmailStatusIcons.propTypes = {
  emailStatus: PropTypes.shape({
    delivery_status: PropTypes.shape({
      delivered: PropTypes.bool,
      email_open: PropTypes.bool,
      email_click: PropTypes.bool,
      bounced: PropTypes.bool,
    }),
  }),
};

EmailStatusIcons.defaultProps = {
  emailStatus: null,
};

export default EmailStatusIcons;
